import _regeneratorRuntime from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { loadAbsorbersPlugin } from "./Plugins/Absorbers";
import { loadEmittersPlugin } from "./Plugins/Emitters";
import { loadExternalTrailInteraction } from "./Interactions/External/Trail";
import { loadPolygonMaskPlugin } from "./Plugins/PolygonMask";
import { loadRollUpdater } from "./Updaters/Roll";
import { loadSlim } from "./slim";
import { loadTiltUpdater } from "./Updaters/Tilt";
import { loadTwinkleUpdater } from "./Updaters/Twinkle";
import { loadWobbleUpdater } from "./Updaters/Wobble";
export function loadFull(_x) {
  return _loadFull.apply(this, arguments);
}
function _loadFull() {
  _loadFull = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadSlim(engine);
          case 2:
            _context.next = 4;
            return loadRollUpdater(engine);
          case 4:
            _context.next = 6;
            return loadTiltUpdater(engine);
          case 6:
            _context.next = 8;
            return loadTwinkleUpdater(engine);
          case 8:
            _context.next = 10;
            return loadWobbleUpdater(engine);
          case 10:
            _context.next = 12;
            return loadExternalTrailInteraction(engine);
          case 12:
            _context.next = 14;
            return loadAbsorbersPlugin(engine);
          case 14:
            _context.next = 16;
            return loadEmittersPlugin(engine);
          case 16:
            _context.next = 18;
            return loadPolygonMaskPlugin(engine);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadFull.apply(this, arguments);
}